module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    style: ({
      height: _vm.chart_height
    }),
    attrs: {
      "id": "canvas-rdari"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cbf9701","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/rdari.vue
// module id = 551
// module chunks = 1